





























































































import Vue from 'vue'
import { mapGetters } from 'vuex'

const documentKeys = {
  national_id: {
    text: 'RUT',
    value: 'national_id'
  },
  foreign_id: {
    text: 'RUT de extranjería',
    value: 'foreign_id'
  }
} as Record<string, {text: string; value: string; }>

export default Vue.extend({
  props: {
    onShowMoreInformation: {
      type: Function,
      required: true
    },
    showMoreInformation: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      documentType: 'national_id',
      identificationNumber: '',
      birthday: '',
      showBirthdayPicker: false
    }
  },
  computed: {
    documentTypeItems () {
      return Object.entries(documentKeys).map(documentKey => {
        return {
          text: this.$t(`${documentKey[1].text}`),
          value: documentKey[1].value
        }
      })
    },
    ...mapGetters('results', ['getChecksCounter', 'getCheckType']),
    ...mapGetters('language', ['getLanguage'])
  },
  methods: {
    buildCheckInput (): Record<string, string> {
      return {
        // @ts-ignore
        [this.documentType]: this.identificationNumber,
        // @ts-ignore
        birthday: this.birthday
      }
    }
  }
})
